export class ClientRelations {
    id:number
    client_id: number
    relation_type: number
    relation_name: string
    relation_address: string
    relation_phone: string
    relation_email: string
    relation_start_date: string
    relation_end_date: string
    
 public constructor(init?: Partial<ClientRelations>) {
        Object.assign(this, init);
    }

    // constructor(
    //     client_id: number,
    //     relation_type_id: number,
    //     relation_name: string,
    //     relation_address: string,
    //     relation_phone: string,
    //     relation_email: string,
    //     relation_start_date: Date,
    //     relation_end_date: Date,
    //     active_flag: number
    // ) {
    //     this.client_id = client_id
    //     this.relation_type_id = relation_type_id
    //     this.relation_name = relation_name
    //     this.relation_address = relation_address
    //     this.relation_phone = relation_phone
    //     this.relation_email = relation_email
    //     this.relation_start_date = relation_start_date
    //     this.relation_end_date = relation_end_date
    //     this.active_flag = active_flag
    // } 
}
